import { Progress } from 'antd';
import React, { FC } from 'react';
import { IItemProgressData } from '@/presentation/pages/traffic/issues/list/statistical-distribution/item';
import styles from './index.module.scss';

export interface ProgressItemProp {
  strokeColor?: string;
  record: IItemProgressData;
  labelWidth?: number;
}

export const ProgressItem: FC<ProgressItemProp> = (props) => {
  const { record } = props;

  return (
    <div
      className={styles.progress}
      data-record={JSON.stringify(record)}
      onMouseEnter={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <span className={styles.metricName} style={{
        maxWidth: props.labelWidth,
      }}>{record.field}</span>
      <Progress
        className={styles.progressItem}
        percent={record.valueRatio * 100}
        strokeColor={props.strokeColor}
        format={() => null}
      />
    </div>
  );
};
